import { render } from "./FinancialAccountCard.vue?vue&type=template&id=64bb8364&scoped=true"
import script from "./FinancialAccountCard.vue?vue&type=script&lang=js"
export * from "./FinancialAccountCard.vue?vue&type=script&lang=js"

import "./FinancialAccountCard.vue?vue&type=style&index=0&id=64bb8364&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bb8364"]])

export default __exports__